import axios from "axios";
import { environment } from "../../environments/environment";

export interface SocialMediaItem {
  type: 'facebook' | 'instagram' | 'linkedin' | 'google';
  url: string;
}

export interface CompanyProfileResponse {
  id: string;
  name: string;
  description?: string;
  motivation?: string;
  email: string;
  phone?: string;
  address?: string;
  address_complement?: string;
  address_number?: string;
  address_district?: string;
  postcode?: string;
  city: string;
  city_id: string;
  segment: {
    id: number;
    name: string;
  };
  segment_id: number;
  escola_do_mecanico?: {
    id: string;
    name: string;
    branch_number: string;
  };
  google_link?: string;
  facebook_link?: string;
  linkedin_link?: string;
  instagram_link?: string;
  website?: string;
  cnpj: string;
  ie?: string;
}

export interface UpdateCompanyProfileData {
  name?: string;
  description?: string;
  motivation?: string;
  email?: string;
  phone?: string;
  address?: string;
  address_complement?: string;
  address_number?: string;
  address_district?: string;
  postcode?: string;
  city_id?: string;
  segment_id?: number;
  google_link?: string;
  facebook_link?: string;
  linkedin_link?: string;
  instagram_link?: string;
  website?: string;
  ie?: string;
}

/**
 * Converte os links de redes sociais da API para o formato usado no frontend
 */
export const convertSocialMediaFromAPI = (companyData: CompanyProfileResponse): SocialMediaItem[] => {
  const socialMedia: SocialMediaItem[] = [];
  
  if (companyData.facebook_link) {
    socialMedia.push({ type: 'facebook', url: companyData.facebook_link });
  }
  if (companyData.instagram_link) {
    socialMedia.push({ type: 'instagram', url: companyData.instagram_link });
  }
  if (companyData.linkedin_link) {
    socialMedia.push({ type: 'linkedin', url: companyData.linkedin_link });
  }
  if (companyData.google_link) {
    socialMedia.push({ type: 'google', url: companyData.google_link });
  }
  
  return socialMedia;
};

/**
 * Converte os links de redes sociais do frontend para o formato da API
 */
export const convertSocialMediaToAPI = (socialMedia: SocialMediaItem[]): Partial<UpdateCompanyProfileData> => {
  const result: Partial<UpdateCompanyProfileData> = {};
  
  socialMedia.forEach(item => {
    if (item.type === 'facebook') {
      result.facebook_link = item.url;
    } else if (item.type === 'instagram') {
      result.instagram_link = item.url;
    } else if (item.type === 'linkedin') {
      result.linkedin_link = item.url;
    } else if (item.type === 'google') {
      result.google_link = item.url;
    }
  });
  
  // Limpar links que não estão mais na lista
  const types = socialMedia.map(item => item.type);
  if (!types.includes('facebook')) result.facebook_link = '';
  if (!types.includes('instagram')) result.instagram_link = '';
  if (!types.includes('linkedin')) result.linkedin_link = '';
  if (!types.includes('google')) result.google_link = '';
  
  return result;
};

/**
 * Busca os dados da empresa
 */
export const getCompanyProfile = async (companyId: string): Promise<CompanyProfileResponse> => {
  const response = await axios.get<CompanyProfileResponse>(
    `${environment.apiUrl}/api/company/${companyId}/`,
    {
      headers: {
        'Content-Type': 'application/json'
      }
    }
  );

  if (response.status !== 200) {
    throw new Error('Erro ao buscar dados da empresa');
  }

  return response.data;
};

/**
 * Atualiza os dados da empresa
 */
export const updateCompanyProfile = async (
  companyId: string,
  data: UpdateCompanyProfileData
): Promise<CompanyProfileResponse> => {
  const response = await axios.patch<CompanyProfileResponse>(
    `${environment.apiUrl}/api/company/${companyId}/`,
    data,
    {
      headers: {
        'Content-Type': 'application/json'
      }
    }
  );

  if (response.status !== 200) {
    throw new Error('Erro ao atualizar dados da empresa');
  }

  return response.data;
};


